// 仪器管理路由
import Layout from "@/layout";

const businessApprovalRoute = [
  {
    component: Layout,
    path: "/approval",
    name: "approval",
    hidden: true,
    meta: {
      title: "审核业务",
      icon: "form"
    },
    children: [
      {
        path: "approval-list",
        component: () => import("@/views/approval/approval"),
        name: "approvalList",
        meta: {
          title: "审批列表",
          icon: "yiqi"
        }
      },
    ]
  }
];
export default businessApprovalRoute;



// WEBPACK FOOTER //
// ./src/router/modules/businessApproval.js